var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tree',{attrs:{"data":_vm.treeData,"options":_vm.treeOptions},on:{"node:selected":_vm.onNodeSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }